import React, { useState } from "react";
import { connect } from "react-redux";
import PhotoSearchCard from "../PhotoSearchCard";
import PropTypes from "prop-types";
import {
  addContactAction,
  deleteContactAction
} from "../../redux/actions/contacts.actions";
import ProfileCardModal from "../modals/ProfileCardModal";

const PhotoSearchTable = ({
  addContactAction,
  contacts,
  deleteContactAction,
  searchResults,
  loggedIn,
  loggedInUser,
  showFullCards
}) => {
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState();

  return (
    <div className="search-layout">
      <div className="row">
        {searchResults.map((searchItem, index) => (
          <div
            className={"col-lg-6 col-md-6"}
            key={`${searchItem.id}_${Math.random()}`}
          >
            <PhotoSearchCard
              key={searchItem.id}
              rowItem={searchItem}
              contacts={contacts}
              fullCard={showFullCards}
              onAdd={addContactAction}
              onRemove={deleteContactAction}
              loggedInUser={loggedInUser}
              isUserLoggedIn={loggedIn}
              onClick={() => {
                setSelectedRow(index);
                setModalOpen(true);
              }}
            />
          </div>
        ))}
      </div>
      <ProfileCardModal
        onToggle={() => {
          setModalOpen(!modalOpen);
        }}
        isOpen={modalOpen}
        profile={searchResults[selectedRow]}
        loggedInUser={loggedInUser}
        isUserLoggedIn={loggedIn}
        onAdd={addContactAction}
        onRemove={deleteContactAction}
        contacts={contacts}
      />
    </div>
  );
};

PhotoSearchTable.propTypes = {
  searchResults: PropTypes.arrayOf(PropTypes.object),
  showFullCards: PropTypes.bool
};

PhotoSearchTable.defaultProps = {
  showFullCards: false
};

const mapStateToProps = state => ({
  loggedInUser: state.profile.profile,
  contacts: state.profile.profile.contacts,
  searchResults: state.profile.searchResults,
  loggedIn: state.auth.loggedIn
});

export default connect(
  mapStateToProps,
  {
    addContactAction,
    deleteContactAction
  }
)(PhotoSearchTable);



// WEBPACK FOOTER //
// ./src/components/PhotoSearchTable/PhotoSearchTable.jsx